class AccordionImage {
	constructor(accordionImageEl) {
		this.el = accordionImageEl;
		this.init();
	}
	
	syncImages() {
		this.el.querySelectorAll('.accordion__image-wrapper').forEach((wrapper) => {
			wrapper.inert = !wrapper.classList.contains('active');
		});
	}

	init() {
		this.syncImages();

		this.el.querySelectorAll('.accordion-container__header').forEach( (el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				this.el.querySelectorAll('.accordion__image-wrapper').forEach(accImageWrapper => {
					accImageWrapper.classList.remove('active');
				});
				// Only show image when the header is active (accordion is open)
				if (el.classList.contains('active')) {
					const accordionImageWrappers = this.el.querySelectorAll('[data-image="' + el.dataset.accHeading + '"]');
					accordionImageWrappers.forEach(imageWrapper => {
						imageWrapper.classList.add('active');
					});
				}
				this.syncImages();
			});
		});
	}
}

export default AccordionImage;